import { TipoDeRecurso } from '@/models/Recurso'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDeWebhooks: RouteConfig[] = [
	{
		path: '/webhooks',
		name: 'Webhooks',
		components: {
			default: () => import('@/views/application/webhooks/TelaDeWebhooks.vue'),
			toolbar: () => import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'webhooks' as TipoDeRecurso,
		},
	},
]

export default rotasDeWebhooks
